/**
 * Sms campaigns mixin
 */
export default {
  name: "SmsCampaignMixin",
  /**
    |--------------------------------------------------
    | Methods
    |--------------------------------------------------
    */
  methods: {
    /**
     * Computes redirect route for sms campaign
     * @description Redirects to sms camapign journery builder page if workflow_id is present and status is {wi} for sms campaign
     * else redirects to campaign sms dashboard page
     * @returns {String} Route to which user have to be redirected
     */
    redirectTo({ id, status, workflow_id }) {
      const account = this.$store.getters["auth/account"];
      let [route, isJourneyStatus] = [`/accounts/${account.id}`,status ===  "wi"];

      const isJourney = isJourneyStatus && workflow_id;
      const isJourneyDeleted = isJourneyStatus && !workflow_id;
      if (isJourney) {
        window.open(`${route}/journeys/${workflow_id}/builder`, "_blank");
      } else if (isJourneyDeleted) {
        window.open(`/404`, "_blank");
      } else if(status == 'trans'){
        this.$router.push(`/accounts/${account.id}/transactional_sms_campaigns/${id}/edit`);
      }
      else{
        this.$router.push(`/accounts/${account.id}/sms_campaigns/${id}/edit`);
      }
    }
  }
};
